import script from "./TermsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsDialog.vue?vue&type=script&setup=true&lang=js"

import "./TermsDialog.vue?vue&type=style&index=0&id=195f6432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195f6432"]])

export default __exports__